import React, { useEffect, useState } from "react";
// mui
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Skeleton,
} from "@mui/material";
// utils
import { userSummary } from "../../../Utilities/dashboardSummary";

export const UserSummary = () => {
  const UserMultipleIcon = "/Assets/Icons/wallet.svg";
  const TrendIcon = "/Assets/Icons/trend.svg";

  const [responseData, setResponseData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await userSummary();
        setResponseData(response);
      } catch (error) {
        console.error("Error fetching user engagement:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const rawData = [
    {
      id: 1,
      name: "Total Users",
      count: responseData?.totalUsers,
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
    {
      id: 2,
      name: "Active Users Today",
      count: responseData?.activeUsersToday,
      icon: TrendIcon,
      color: "#18DC8B",
    },
    {
      id: 3,
      name: "Currently Active Users",
      count: responseData?.currentlyOnlineUsers,
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
    {
      id: 4,
      name: "This Week New Users",
      count: responseData?.newUsersThisWeek,
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
  ];
  return (
    <React.Fragment>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {loading
          ? [...Array(4)].map((_, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  variant="outlined"
                  sx={{
                    mt: 1,
                    border: "1px solid #1A1A1A",
                    background: "#1A1A1A",
                    border: "1px solid rgba(255, 224, 51, 0.20)",
                  }}
                >
                  <CardContent>
                    <Skeleton
                      width="60%"
                      height={20}
                      sx={{ mt: 1, background: "#fff" }}
                    />
                    <Skeleton
                      width="40%"
                      height={30}
                      sx={{ mt: 1, background: "#fff" }}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))
          : rawData?.map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item?.id}>
                <Card
                  sx={{
                    backgroundColor: "#242424",
                    color: "white",
                    padding: 2,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    border: "1px solid rgba(255, 224, 51, 0.20)",
                  }}
                >
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ color: "#FFD700", fontWeight: 600, fontSize: 14 }}
                    >
                      {item?.name}
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: 400, mt: 1, fontSize: 24 }}
                    >
                      {item?.count}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "rgba(255, 215, 0, 0.20)",
                      padding: 1,
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item?.icon}
                      alt={item?.name}
                      style={{ width: 24, height: 24 }}
                    />
                  </Box>
                </Card>
              </Grid>
            ))}
      </Grid>
    </React.Fragment>
  );
};
